<template>
  <div>
    <el-header class="skill-group-content">
      <h3 class="title">
        <div class="block">
          <span>基本设置</span>
        </div>
      </h3>
    </el-header>
    <div style="display:flex; margin-top: 20px">
      <div class="setting-left">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item prop="nickname">
            <div><span style="color:red">* </span>昵称</div>
            <el-input v-model="form.nickname"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="password">
            <div><span style="color:red;">* </span>密码</div>
            <el-input v-model="form.password"></el-input>
          </el-form-item> -->
          <!-- <el-form-item prop="email">
            <div>邮箱</div>
            <el-input v-model="form.email"></el-input>
          </el-form-item> -->
          <el-form-item prop="welcome">
            <div>接入专属提示语</div>
            <el-input v-model="form.welcome"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="onSubmit">更新基本信息</el-button>
          </el-form-item>
        </el-form>
      </div>
       <div class="setting-right">
         <h5>头像</h5>
        <el-upload
          :before-upload="beforeImageUpload"
          :on-success="handleImageUpload"
          :show-file-list="false"
          :headers="headers"
          :with-credentials="true"
          :action="imageUploadAction">
          <el-avatar shape="square" :size="80" :src="imageSrc"></el-avatar>
          <div>
            <i class="el-icon-camera-solid" />
            <el-button type="text">修改头像</el-button>
            <span style="padding-left:10px;color:#999;">大小：不超过1M，格式：png,jpg,gif，尺寸建议采用正方形头像</span>
          </div>
        </el-upload>
      </div>
    </div>
  </div>
</template>
<script>
import { addUser, getUser } from '@/api/user'
import { mapActions } from 'vuex'

export default {
  data() {
    var validatePwd = (rule, value, callback) => {
      if (value === '••••••') {
        callback()
      } else {
        if (
          // 参考链接:https://www.html.cn/archives/8100
          // (?=.*[A-Za-z])表示至少1个大写或小写字母、(?=.*\d)表示至少1个数字、(?=.*[$@!%*?&])表示至少有1个特殊字符，{6,16}表示6-16个长度
          // /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&].{8,14}$/.test(value) ||
          // /^(?=.*\d)(?=.*[$@!%*?&])[A-Za-z\d@$!%*?&].{8,14}$/.test(value) ||
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[$@!%*?&#^_-])(?=.*\d)[\da-zA-Z$@!%*?&#^_-]{8,14}$/.test(value)
        ) {
          // 如果包含了英文/数字/常用半角符号中的两项,则放行，否则认为密码强度不够
          callback()
        } else {
          callback(new Error('长度8-14个字，需包含大写字母、小写字母、数字及符号'))
        }
      }
    }
    return {
      imageSrc: '',
      form: {
        id: '',
        userName: '',
        idNum: '',
        password: '',
        confirmpwd: '',
        nickname: '',
        realName: '',
        email: '',
        mobile: '',
        roleId: '',
        maxReception: '',
        groupId: '',
        welcome: '',
        avatar: '',
        chargeGroup: false
      },
      imageUploadAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/upload/file?fileType=6&isTemp=false',
      imageDownloadAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/download',
      rules: {
        // 密码
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePwd, trigger: 'blur' }
        ],
        // 昵称
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min: 2, max: 12, message: '长度2-12个字，支持中文、英文、数字', trigger: 'blur' },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: '仅支持中文、英文、数字',
            trigger: 'blur'
          }
        ],
        // 邮箱
        email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
        // 欢迎语
        welcome: [
          { max: 50, message: '字符长度0-50个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    headers() {
      return {
        'X-TENANT-ID': localStorage.getItem('X-TENANT-ID')
      }
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    ...mapActions('user', ['handleLogOut']),
    getUserInfo() {
      const userId = this.$store.state.user.userInfo.id
      getUser(userId).then(res => {
        if (res.code === 2000) {
          const data = res.data
          this.form.id = data.id
          this.form.userName = data.userName
          this.form.idNum = data.idNum
          this.form.password = '••••••'
          this.form.nickname = data.nickname
          this.form.realName = data.realName
          this.form.email = data.email
          this.form.mobile = data.mobile
          this.form.roleId = data.roleId
          this.form.maxReception = data.maxReception
          this.form.groupId = data.userGroupId
          this.form.welcome = data.welcome
          this.form.avatar = data.avatar
          this.form.chargeGroup = data.charge
          this.imageSrc = data.avatar === null ? './home/images/robotAgent.jpg' : (this.imageDownloadAction + data.avatar)
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 图片上传检查
    beforeImageUpload(img) {
      const isValid = (img.type === 'image/png' || img.type === 'image/jpeg' || img.type === 'image/gif')
      const isLt2M = img.size / 1024 / 1024 < 1
      if (!isValid) {
        this.$message.error('上传头像图片只能是JPG或GIF格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过1MB!')
      }
      return isValid && isLt2M
    },

    // 图片上传加工处理
    handleImageUpload(res) {
      this.form.avatar = res.url
      this.imageSrc = this.imageDownloadAction + res.url
    },

    onSubmit() {
      const that = this
      that.$refs.form.validate(valid => {
        // 表单校验通过,提交到后端
        if (valid) {
          if (this.form.password !== '••••••') {
            this.$confirm('密码修改后当前账号将被强制下线，请您确认是否需要继续修改？', '', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              showClose: false,
              type: 'warning'
            }).then(() => {
              this.updateUser()
            }).catch(() => {})
          } else {
            this.updateUser()
          }
        } else {
          // 表单校验不通过,驳回重新填写
          return false
        }
      })
    },
    updateUser() {
      addUser(this.form).then(res => {
        if (res.code === 2000) {
          this.$message.success('编辑基本信息成功')
          // 修改密码则踢出当前用户，重新登录
          if (this.form.password !== '••••••') {
            this.knickCurrentUser()
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    knickCurrentUser() {
      this.handleLogOut().then(res => {
        if (res.code === 2000) {
          // localStorage.clear()
          window.location.href = window.$envUtils('VUE_APP_BP_URL')
        }
      }).catch(err => {
        this.$message.error(err)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.el-input{
  text-align: center;
}
.el-form-item{
  margin-bottom: 20px;
}
.setting-left {
  width: 500px;
  margin-right: 40px;
}

.setting-right {
  h5 {
    font-size: 14px;
    color: #333;
    line-height: 40px;
    margin-bottom: 15px;
  }
  .el-upload {
    text-align: left;
    .el-icon-camera-solid {
      font-size: 14px;
      color: #337eff;
      margin-right: 2px;
    }
    .el-button {
      color: #337eff;
    }
  }
}
</style>
<style lang="scss" scope>
.el-message-box__btns {
    font-size: 18px;
    text-align: center;
}
.el-upload{text-align:left;}
</style>
<style lang="scss">
.el-avatar > img {
  width: 100%;
  object-fit:fill !important; // 填充则改 fill
}
</style>
